import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class AgentWhitelistEntry extends MongoEntity {
  static override _class = 'AgentWhitelistEntry';
  static override _collectionName = 'agent-whitelist-entries';

  @validate(nonOptional())
  @Field(() => String)
  agent: Maybe<string>;

  @Field(() => String)
  note: Maybe<string>;
}
